<template>
    <div>
        <div class="VueTables__primary-content">
            {{ trans(`reporting.status.${status}`) }}
        </div>
        <div class="VueTables__secondary-content" v-if="completedDate">
            {{ completedDate }}
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['data', 'filter'],

    computed: {
        status() {
            return this.singleRelevantAssignment
                ? this.singleRelevantAssignment.status
                : this.data.status;
        },
        singleRelevantAssignment() {
            const { data, filter } = this;
            const { assignments } = data;
            const { filterByCourse } = filter;

            if (assignments.length === 1) {
                return data.assignments[0];
            }
            if (filterByCourse) {
                return assignments.find(
                    ({ course_id }) => course_id == filterByCourse.id
                );
            }
            return null;
        },
        completedDate() {
            if (
                this.singleRelevantAssignment &&
                this.singleRelevantAssignment.status == 'completed'
            ) {
                return moment(this.singleRelevantAssignment.finished_at).format(
                    'DD.MM.YYYY'
                );
            }
            return null;
        }
    }
};
</script>
